import BaseService from '@/ecm/common/BaseService.js';

class UserSearchService {
  baseUrl = 'user-searches';

  delete = (userSearchId) => BaseService.delete({ url: `${this.baseUrl}/${userSearchId}` });
  getGroupAndSortSettings = (id) => BaseService.get({ url: `${this.baseUrl}/group-sort-settings/${id}` });
}

export default new UserSearchService();